import { render, staticRenderFns } from "./DYNA.vue?vue&type=template&id=17663403&scoped=true"
import script from "./DYNA.vue?vue&type=script&lang=js"
export * from "./DYNA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17663403",
  null
  
)

export default component.exports